import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconModule } from '@y42/core/icon';
import { ImportTypeComponent } from './import-type.component';

@NgModule({
  imports: [CommonModule, MatTooltipModule, FontAwesomeModule, IconModule],
  exports: [ImportTypeComponent],
  declarations: [ImportTypeComponent],
})
export class ImportTypeModule {}
